window._ = require('lodash');

var csrfToken = $('meta[name="csrf-token"]').attr('content');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN']     = csrfToken;

window.$ = window.jQuery = global.$ = global.jQuery = require('jquery')

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': csrfToken
    }
});

const token = window.localStorage.getItem('access_token');
// noinspection ES6UnusedImports
import Echo from 'laravel-echo';

require('bootstrap');



require('egalink-toasty.js');

window.dayjs = require('dayjs')

let relativeTime = require('dayjs/plugin/relativeTime');
let duration     = require('dayjs/plugin/duration')
let timezone     = require('dayjs/plugin/timezone')
let utc          = require('dayjs/plugin/utc')

dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(utc);

global.toast = window.toast = new Toasty({
    classname   : "toast",
    transition  : "fade",
    insertBefore: true,
    duration    : 20000,
    enableSounds: false,
    autoClose   : false,
    progressBar : false,
    sounds      : {
        // path to sound for informational message:
        info   : "./dist/sounds/info/1.mp3",    // path to sound for successful message:
        success: "./dist/sounds/success/1.mp3", // path to sound for warn message:
        warning: "./dist/sounds/warning/1.mp3", // path to sound for error message:
        error  : "./dist/sounds/error/1.mp3",
    },

    // callback:
    // onShow function will be fired when a toast message appears.
    onShow: function (type) {
    },

    // callback:
    // onHide function will be fired when a toast message disappears.
    onHide: function (type) {
    },

    // the placement where prepend the toast container:
    prependTo: document.body.childNodes[0]
});
